var React = require('react');

function HomeIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Component 1","opacity":"0.8"},[React.createElement("path",{"id":"Vector 128","d":"M3 12L12 3L21 12","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector 129","d":"M5.5 14.5L5.5 20.5C5.5 20.7761 5.72386 21 6 21H18C18.2761 21 18.5 20.7761 18.5 20.5V14.5","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":1})]));
}

HomeIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = HomeIcon;

HomeIcon.default = HomeIcon;
